var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoposts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27965_240448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2542 76.5185L36.8185 176.846C36.3155 184.689 42.3653 191.41 50.2178 191.731L171.063 196.673C178.763 196.987 185.27 191.019 185.62 183.32L190.154 83.6042L187.693 82.3803L43.2542 76.5185Z",
    fill: "#A9DDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2542 76.5185L187.693 82.3803L190.154 83.6042L191.869 45.8661C192.029 42.345 189.312 39.3573 185.792 39.1833L52.3911 32.59C48.8974 32.4173 45.9122 35.0816 45.6883 38.5725L43.2542 76.5185Z",
    fill: "#0B69AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8542 75.3193L34.4185 175.647C33.9154 183.49 39.9653 190.211 47.8178 190.532L168.663 195.473C176.363 195.788 182.87 189.82 183.22 182.121L187.754 82.405L40.8542 75.3193Z",
    fill: "#BDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8542 75.3193L187.754 82.405L189.469 44.6669C189.629 41.1458 186.912 38.1581 183.392 37.9841L49.9911 31.3908C46.4973 31.2181 43.5122 33.8824 43.2883 37.3733L40.8542 75.3193Z",
    fill: "#048FF3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27965_240448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.714 83.7676L184.206 81.3337L36.3667 71.6617L24.8215 174.675C23.8645 182.952 30.1776 190.266 38.4452 190.459L164.701 193.4C172.088 193.572 178.344 187.946 179.011 180.53L187.714 83.7676Z",
    fill: "#6D6767",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3667 71.6617L184.206 81.3337L187.714 83.7676L191.176 45.276C191.498 41.6934 188.778 38.5688 185.211 38.4242L47.029 32.8235C43.768 32.6913 40.9566 35.1132 40.579 38.3798L36.3667 71.6617Z",
    fill: "#6D6767",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.314 82.168L181.806 79.7341L33.9667 70.062L22.4215 173.075C21.4645 181.353 27.7776 188.667 36.0452 188.859L162.301 191.8C169.688 191.972 175.944 186.346 176.611 178.93L185.314 82.168Z",
    fill: "#AADFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9667 70.062L181.806 79.7341L185.314 82.168L188.776 43.6764C189.098 40.0938 186.378 36.9692 182.811 36.8246L44.629 31.2239C41.368 31.0917 38.5566 33.5136 38.1789 36.7802L33.9667 70.062Z",
    fill: "#0669B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.973 80.5363L31.6262 71.6385L20.081 170.874C19.1241 179.099 25.4371 186.368 33.7048 186.559L159.961 189.481C167.348 189.652 173.603 184.062 174.27 176.692L182.973 80.5363Z",
    fill: "#BDFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6262 71.6385L182.973 80.5363L186.435 42.2859C186.757 38.7257 184.037 35.6207 180.47 35.477L42.2885 29.9114C39.0275 29.78 36.2161 32.1867 35.8385 35.4329L31.6262 71.6385Z",
    fill: "#048FF3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_f_27965_240448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.051 36.5719L47.8268 30.9781C44.6547 30.8479 41.8667 33.0626 41.2759 36.1819L35.4577 70.7057L180.254 77.9421L183.275 81.1448L190.083 44.1241C190.787 40.2963 187.94 36.7315 184.051 36.5719Z",
    fill: "#6D6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.275 81.1448L180.254 77.9421L35.4577 70.7057L15.7725 170.853C14.1876 179.221 20.3806 187.054 28.8892 187.443L143.781 192.69C154.566 193.183 164.058 185.637 166.01 175.02L183.275 81.1448Z",
    fill: "#6D6767"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.651 32.9723L43.4267 27.3785C40.2547 27.2483 37.4666 29.463 36.8759 32.5823L30.8786 66.6143L176.915 74.7212L178.875 77.5452L185.683 40.5245C186.387 36.6967 183.54 33.1319 179.651 32.9723Z",
    fill: "#0573C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.875 77.5452L176.915 74.7212L30.8786 66.6143L11.3725 167.253C9.78761 175.622 15.9805 183.455 24.4892 183.843L139.381 189.091C150.166 189.583 159.658 182.038 161.61 171.42L178.875 77.5452Z",
    fill: "#AEE2E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.651 30.1715L41.4267 24.5777C38.2547 24.4475 35.4666 26.6622 34.8759 29.7815L27.8111 67.087L176.875 74.7444L183.683 37.7237C184.387 33.8959 181.54 30.3312 177.651 30.1715Z",
    fill: "#048FF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.875 74.7444L27.8111 67.087L9.37246 164.452C7.78761 172.821 13.9805 180.654 22.4892 181.043L137.381 186.29C148.166 186.783 157.658 179.237 159.61 168.619L176.875 74.7444Z",
    fill: "#CBFCFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.0381,
    cy: 42.5059,
    r: 6.08484,
    transform: "rotate(20.9052 59.0381 42.5059)",
    fill: "#054370"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2884 38.1494C62.711 37.5855 62.0113 37.1279 61.2093 36.8216C58.07 35.6225 54.5529 37.1953 53.3538 40.3347C52.1547 43.474 53.7276 46.9911 56.8669 48.1902C57.9573 48.6067 59.0933 48.6888 60.1619 48.4869C58.479 46.8434 57.8351 44.2966 58.7279 41.9592C59.5105 39.9103 61.2805 38.5286 63.2884 38.1494Z",
    fill: "#2B8ED6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27965_240448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4698 44.9625C64.113 48.5146 60.1336 50.2942 56.5815 48.9375C53.0294 47.5807 51.2498 43.6013 52.6066 40.0492C53.9633 36.4971 57.9428 34.7174 61.4949 36.0742C65.0469 37.431 66.8266 41.4104 65.4698 44.9625ZM56.867 48.1901C60.0063 49.3893 63.5234 47.8164 64.7225 44.677C65.9216 41.5377 64.3487 38.0207 61.2094 36.8215C58.07 35.6224 54.553 37.1953 53.3539 40.3346C52.1548 43.474 53.7276 46.991 56.867 48.1901Z",
    fill: "#3CA8F6"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 150.279,
    cy: 47.425,
    r: 6.08484,
    transform: "rotate(15 150.279 47.425)",
    fill: "#054370"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.059 42.6544C153.427 42.1529 152.683 41.7697 151.854 41.5475C148.608 40.6778 145.272 42.6041 144.402 45.8502C143.532 49.0962 145.458 52.4328 148.704 53.3025C149.832 53.6046 150.97 53.5694 152.013 53.2587C150.169 51.797 149.267 49.33 149.915 46.9132C150.482 44.7946 152.101 43.2382 154.059 42.6544Z",
    fill: "#2B8ED6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_27965_240448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.93 49.2075C155.945 52.8804 152.17 55.06 148.497 54.0759C144.825 53.0917 142.645 49.3165 143.629 45.6437C144.613 41.9709 148.388 39.7912 152.061 40.7754C155.734 41.7595 157.914 45.5347 156.93 49.2075ZM148.704 53.3031C151.951 54.1729 155.287 52.2465 156.157 49.0005C157.027 45.7544 155.1 42.4179 151.854 41.5481C148.608 40.6783 145.272 42.6047 144.402 45.8507C143.532 49.0968 145.458 52.4333 148.704 53.3031Z",
    fill: "#3CA8F6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.1641 48.4877C60.1641 48.4877 63.1571 48.1117 64.5668 44.9025C65.9766 41.6934 64.5844 39.9955 64.5844 39.9955C64.0963 40.0882 62.7968 40.1057 62.2968 40.0619C57.5994 39.651 54.332 33.1375 54.999 25.5137C55.666 17.89 60.0148 12.0428 64.7122 12.4538C69.1684 12.8437 72.3376 18.7254 72.0819 25.837L77.4066 26.069C78.0021 14.2859 72.8106 4.49022 65.4651 3.84758C57.8391 3.18038 50.7791 12.6729 49.6962 25.0498C48.6919 36.5289 53.4234 46.5755 60.1641 48.4877Z",
    fill: "#EB5F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7225 48.3697C60.7225 48.3697 63.6381 47.9327 64.7446 44.6198C65.8511 41.3068 64.575 39.9861 64.575 39.9861C64.0869 40.0788 63.5968 40.1057 63.0968 40.0619C58.3993 39.651 55.132 33.1375 55.799 25.5137C56.466 17.89 60.8147 12.0428 65.5122 12.4538C69.9684 12.8437 73.1428 18.7589 72.8871 25.8705L78.2065 26.1074C78.8021 14.3243 73.6106 4.49022 66.2651 3.84758C58.639 3.18038 51.5791 12.6729 50.4962 25.0498C49.4919 36.5289 53.9818 46.4575 60.7225 48.3697Z",
    fill: "#FC754B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2198 26.1303C52.1277 28.2315 52.3531 29.9813 52.0107 29.9662C51.6683 29.9512 51.4655 28.2357 51.5576 26.1346C51.6498 24.0334 52.002 22.3422 52.3444 22.3573C52.6868 22.3723 52.312 24.0291 52.2198 26.1303Z",
    fill: "#FDB8A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6912 5.8819C65.3674 5.63849 64.4205 6.02792 64.5304 5.42989C64.6404 4.83185 65.8026 4.54437 67.1264 4.78778C68.4501 5.03119 69.434 5.71332 69.3241 6.31135C69.2141 6.90938 68.0149 6.12531 66.6912 5.8819Z",
    fill: "#FDB8A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7417 48.3619C63.7294 47.3948 65.6115 42.4794 64.5734 39.9824C64.5734 39.9824 65.88 41.2477 64.7386 44.6529C63.5972 48.0582 60.7417 48.3619 60.7417 48.3619Z",
    fill: "#735A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.992 53.2659C151.992 53.2659 154.644 52.6357 155.897 49.7315C156.695 46.5367 155.841 44.9721 155.841 44.9721C155.353 45.0648 154.56 44.9006 154.06 44.8569C149.362 44.4459 146.095 37.9324 146.762 30.3087C147.429 22.6849 151.778 16.8378 156.475 17.2487C160.931 17.6386 164.106 22.4958 163.851 29.6074L169.17 29.8265C169.765 18.0434 164.574 9.28514 157.228 8.6425C149.602 7.9753 142.542 17.4679 141.459 29.8447C140.455 41.3238 145.251 51.3536 151.992 53.2659Z",
    fill: "#EB5F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.323 53.1603C152.323 53.1603 154.354 52.8918 155.722 50.1323C157.09 47.3728 155.845 44.9737 155.845 44.9737C155.684 44.9779 155.444 45.0217 154.944 44.978C150.246 44.567 146.979 38.0535 147.646 30.4298C148.313 22.806 152.661 16.9589 157.359 17.3698C161.815 17.7597 164.98 22.53 164.724 29.6416L170.053 29.8621C170.649 18.079 165.457 9.40624 158.112 8.76359C150.486 8.0964 143.426 17.589 142.343 29.9658C141.339 41.4449 145.582 51.248 152.323 53.1603Z",
    fill: "#FC754B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.983 30.9252C143.89 33.0264 144.116 34.7762 143.774 34.7612C143.431 34.7462 143.228 33.0307 143.32 30.9295C143.413 28.8283 143.765 27.1372 144.107 27.1522C144.45 27.1672 144.075 28.8241 143.983 30.9252Z",
    fill: "#FDB8A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.454 10.6768C157.13 10.4334 156.183 10.8228 156.293 10.2248C156.403 9.62677 157.565 9.33929 158.889 9.5827C160.213 9.82611 161.197 10.5082 161.087 11.1063C160.977 11.7043 159.778 10.9202 158.454 10.6768Z",
    fill: "#FDB8A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.321 53.1554C155.453 51.6722 156.678 47.4922 155.841 44.9668C155.841 44.9668 157.176 47.0372 155.817 49.9592C154.458 52.8812 152.321 53.1554 152.321 53.1554Z",
    fill: "#735A52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.129 141.498C110.867 142.719 109.671 143.501 108.448 143.252L100.013 141.534C98.7726 141.282 97.9764 140.066 98.2403 138.829L103.608 113.654C103.871 112.421 103.081 111.209 101.846 110.951L98.372 110.225C97.1219 109.964 96.3309 108.726 96.6193 107.482L97.1377 105.246C97.4162 104.044 98.6026 103.303 99.8333 103.383C104.456 103.682 108.313 101.854 110.309 98.9499C110.941 98.029 112.018 97.4134 113.11 97.6476L117.976 98.6904C119.205 98.9539 119.988 100.164 119.725 101.394L111.129 141.498Z",
    fill: "#0E6AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.006 139.633C108.743 140.862 107.532 141.645 106.303 141.382L100.304 140.096C99.0746 139.833 98.2915 138.622 98.555 137.393L103.622 113.753C103.885 112.524 103.102 111.313 101.873 111.05L96.0072 109.792C94.7776 109.529 93.9945 108.318 94.2581 107.089L94.8067 104.529C95.0684 103.308 96.2659 102.545 97.5114 102.628C102.094 102.934 105.906 101.2 107.882 98.4195C108.527 97.5123 109.6 96.9006 110.688 97.1338L115.563 98.1786C116.792 98.4422 117.576 99.6526 117.312 100.882L109.006 139.633Z",
    fill: "#048FF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5487 116.816C67.0595 120.429 66.9067 124.017 67.5299 126.79C68.1719 129.424 69.5262 131.306 72.1414 131.66C74.8111 132.021 76.5624 130.56 77.8818 128.191C79.2744 125.691 80.0811 122.192 80.5702 118.578C81.0594 114.965 81.2123 111.377 80.5345 108.597C79.8925 105.963 78.5927 104.088 75.923 103.727C73.3078 103.373 71.502 104.827 70.1827 107.195C68.8445 109.703 68.0378 113.202 67.5487 116.816ZM58.9403 115.65C59.6928 110.091 61.1086 104.552 64.2001 100.159C67.1543 95.9593 71.5098 93.2941 77.2306 94.0686C83.0058 94.8505 86.4959 98.5778 88.2273 103.411C90.0393 108.468 89.9312 114.185 89.1786 119.744C88.4261 125.303 87.0103 130.842 83.9189 135.235C80.974 139.365 76.6091 142.1 70.8338 141.318C65.1131 140.544 61.6324 136.747 59.8916 131.983C58.0796 126.926 58.1877 121.209 58.9403 115.65Z",
    fill: "#0E6AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2021 115.985C64.713 119.599 64.5601 123.187 65.1833 125.96C65.8254 128.594 67.1796 130.476 69.7948 130.83C72.4645 131.191 74.2158 129.73 75.5352 127.361C76.9278 124.861 77.7345 121.362 78.2237 117.748C78.7128 114.135 78.8657 110.547 78.188 107.767C77.5459 105.132 76.2462 103.258 73.5765 102.897C70.9613 102.543 69.1555 103.997 67.8361 106.365C66.4979 108.873 65.6913 112.372 65.2021 115.985ZM56.5937 114.82C57.3463 109.261 58.7621 103.722 61.8535 99.3285C64.8077 95.1292 69.1633 92.464 74.884 93.2385C80.6593 94.0204 84.1494 97.7477 85.8807 102.581C87.6928 107.638 87.5846 113.355 86.8321 118.914C86.0795 124.473 84.6637 130.012 81.5723 134.405C78.6275 138.535 74.2625 141.27 68.4873 140.488C62.7665 139.713 59.2858 135.917 57.5451 131.152C55.733 126.096 55.8412 120.379 56.5937 114.82Z",
    fill: "#048FF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27965_240448",
    x: 8.72546,
    y: 16.8184,
    width: 198.476,
    height: 192.586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_27965_240448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27965_240448",
    x: -0.47583,
    y: 14.9727,
    width: 206.666,
    height: 193.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_27965_240448"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27965_240448",
    x: 51.1515,
    y: 34.6191,
    width: 15.7734,
    height: 15.7734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.421653 0 0 0 0 0.725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27965_240448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27965_240448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_27965_240448",
    x: 142.393,
    y: 39.5391,
    width: 15.7731,
    height: 15.7734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.421653 0 0 0 0 0.725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27965_240448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27965_240448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27965_240448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0.5 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoposts);
export default __webpack_public_path__ + "static/media/noposts.909aeae1144c36034281d516261bec66.svg";
export { ForwardRef as ReactComponent };